import React, { useState, useEffect } from "react";
import { mdiClose } from "@mdi/js";
import { useSelector } from "react-redux";
import Specs from "../../views/results/specs/Specs.js";
import Icon from "@mdi/react";
import products from "db/products.json";
import productsConfiguration from "db/products_configurations.json";
import { Fragment } from "react";
import logo from "assets/logo-black.svg";
import "./DetailProduct.scss";
import { Link } from "react-router-dom";
import { formatPlacca, getObjDifference } from "utils/products.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getBase64 } from "utils/base64.js";
import { printPdf } from "utils/printPdf.js";
import { replaceChar } from "utils/general.js";
import Danger from "assets/icons/Danger.js";
pdfMake.addVirtualFileSystem(pdfFonts);

const dimensions_refs = {
  9: "3/8",
  13: "1/2",
  15: "5/8",
  17: "3/4",
  21: "1",
};

const DetailProduct = ({ product, propRef, close, catalogue }) => {
  const [base64, setBase64] = useState("");
  const [allResultsBase64] = useState([]);
  const [imgBase64, setImgBase64] = useState("");
  const [logoBase64, setLogoBase64] = useState("");
  const ref = React.createRef();
  const title = product?.name;
  const circles = useSelector(({ circles }) => circles);
  const spareParts = product.cap?.split(" ");
  spareParts?.shift();

  const formattedPlacca = formatPlacca(circles);

  const getCouplings = (product) => {
    const copy = { ...product };
    delete copy.brand;
    delete copy.cap;
    delete copy.code;
    delete copy.name;
    delete copy.description;
    delete copy.parking_station;
    delete copy.series;
    delete copy.total_lines;
    delete copy.picture;
    delete copy.drawing;
    delete copy.note_on_version;
    delete copy.max_resistance;
    return copy;
  };

  const dbProduct = products.find((prod) => prod.code === product.code);
  const databaseCouplings = getCouplings(dbProduct);

  const getConfigurationQuantity = (name, formattedPlacca) => {
    let quantity = 0;
    formattedPlacca.forEach((circle) => {
      const number = Object.keys(circle).filter((code) => code === name).length;
      quantity += number;
    });
    return quantity;
  };

  const getProductType = (p) => {
    const descriptions = (p || product).name?.split(" ");
    return descriptions[0] + " " + descriptions[1];
  };
  const type = getProductType()?.split(" ")[1];

  const parkingStation =
    typeof product.parking_station === "string"
      ? product.parking_station.split(" ")
      : null;

  parkingStation && parkingStation.shift();

  const filteredCouplings =
    catalogue || product?.name?.includes("COMPLETE")
      ? Object.entries(databaseCouplings).filter(
          ([key, value]) => typeof value === "number"
        )
      : Object.entries(getObjDifference(product, dbProduct))
          .map(([key, value]) => {
            return [key, getConfigurationQuantity(key, formattedPlacca)];
          })
          .filter(([key, value]) => value > 0 && typeof value === "number");

  const image = () => {
    let image;
    try {
      image = require("assets/jpeg/" + product.picture + ".jpg");
      return image.default;
    } catch (e) {
      console.log("err image not found", e);
    }
  };

  const imageToBase64 = () => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", image(), true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      var reader = new FileReader();
      reader.onload = function (event) {
        var res = event.target.result;

        setImgBase64(res);
      };
      var file = this.response;
      reader.readAsDataURL(file);
    };
    xhr.send();
  };

  const logoToBase64 = () => {
    try {
      const logoImage = require("assets/logo.png");
      var xhr = new XMLHttpRequest();
      xhr.open("GET", logoImage.default, true);
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        var reader = new FileReader();
        reader.onload = function (event) {
          var res = event.target.result;
          setLogoBase64(res);
        };
        var file = this.response;
        reader.readAsDataURL(file);
      };
      xhr.send();
    } catch (e) {
      console.log("err logo not found", e);
    }
  };

  const setAttachments = async () => {
    const selectedAttachment = await getBase64(
      catalogue,
      circles,
      product,
      getProductType(product).split(" ")[1],
      filteredCouplings,
      "printPage",
      imgBase64,
      formattedPlacca,
      logoBase64
    );
    setBase64(selectedAttachment);
  };

  useEffect(() => {
    imageToBase64();
    logoToBase64();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // WARNINGS;

  useEffect(() => {
    setAttachments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgBase64, logoBase64]);

  const splitAndShift = (string) => {
    return string.split(" ").slice(1).join(" ");
  };

  const getRelatedEmpties = () => {
    const code = product.name
      .split("MULTI")
      .join("")
      .split("COMPLETE")
      .join("")
      .split("FIX")
      .join("")
      .split("MOBILE")
      .join("")
      .split("EMPTY")
      .join("")
      .split("- CAP")
      .join("")
      .trim();

    const matching = products.filter(
      (prod) => prod.name.includes(code) && prod.name.includes("EMPTY")
    );

    return matching;
  };

  const relatedEmpties = getRelatedEmpties();

  // Determina il link del video in base al modello (DP o GR)
  const getVideoLink = () => {
    const productName = product?.name || "";
    if (productName.includes("DP")) {
      return "https://www.youtube.com/watch?v=DwG5-ewXR54&list=PLTWc2XFBYEDBa6Wdb-LQ1xbJF3mlADtii&index=9&pp=gAQBiAQB0gcJCccJAYcqIYzv";
    } else if (productName.includes("GR")) {
      return "https://www.youtube.com/watch?v=oWsJ9Dmlh6w&list=PLTWc2XFBYEDBa6Wdb-LQ1xbJF3mlADtii&index=10&pp=gAQBiAQB";
    }
    return null;
  };

  const videoLink = getVideoLink();

  const getPlugSeeger = (freeDimensions) => {
    if (!product) return [];

    const plugsAndSeegers = [];

    // Itera su tutte le chiavi del product
    Object.keys(product).forEach((key) => {
      // Controlla se la chiave inizia con "PLUG-" o "SEEGER-"
      if (key.startsWith("PLUG-") || key.startsWith("SEEGER-")) {
        const productQuantity = product[key];

        // Aggiungi solo se la quantità nel product è maggiore di 0
        if (productQuantity > 0) {
          // Estrae la dimensione (numero dopo il "-")
          const dimensionNumber = key.split("-")[1];
          // Converte la dimensione numerica usando la mappa dimensions_refs
          const dimension = dimensions_refs[dimensionNumber] || dimensionNumber;

          // Controlla se la dimensione è disponibile nelle freeDimensions
          if (
            freeDimensions.hasOwnProperty(dimension) &&
            freeDimensions[dimension] > 0
          ) {
            // Cerca il match in productsConfiguration
            const matched = productsConfiguration.find(
              ({ code }) => code === key
            );

            if (matched) {
              if (key.startsWith("PLUG-")) {
                // I PLUG hanno fixed (femmina) e mobile (maschio)
                // Crea due item
                plugsAndSeegers.push({
                  code: matched.fixed,
                  description: "F " + key,
                  dimension: dimension,
                  quantity: freeDimensions[dimension],
                });

                plugsAndSeegers.push({
                  code: matched.mobile,
                  description: "M " + key,
                  dimension: dimension,
                  quantity: freeDimensions[dimension],
                });
              } else if (key.startsWith("SEEGER-")) {
                // I SEEGER hanno solo fixed ma servono 2 pezzi (1 per piastra fissa + 1 per mobile)
                // È lo stesso articolo usato 2 volte

                plugsAndSeegers.push({
                  code: matched.fixed,
                  description: key,
                  dimension: dimension,
                  quantity: freeDimensions[dimension] * 2, // ✅ Quantità doppia, stesso codice
                });
              }
            }
          }
        }
      }
    });

    return plugsAndSeegers;
  };

  const getPlugAndSeegerConfiguration = () => {
    // Ottiene i filteredCouplings (stessa logica usata per la tabella)
    const couplings =
      catalogue || product?.name?.includes("COMPLETE")
        ? Object.entries(databaseCouplings).filter(
            ([key, value]) => typeof value === "number"
          )
        : Object.entries(getObjDifference(product, dbProduct))
            .map(([key, value]) => {
              return [key, getConfigurationQuantity(key, formattedPlacca)];
            })
            .filter(([key, value]) => value > 0 && typeof value === "number");

    // Funzione per estrarre la dimensione dal coupling
    const extractDimension = (coupling) => {
      // Linea idraulica (inizia con FAP)
      if (coupling.startsWith("FAP")) {
        // Estrae il numero dopo "FAP", ignorando eventuali lettere dopo il numero
        const match = coupling.match(/FAP(\d+)/);
        if (match) {
          const dimensionNumber = match[1];
          return dimensions_refs[dimensionNumber] || dimensionNumber;
        }
      }

      // Linea elettrica (inizia con EC)
      if (coupling.startsWith("EC")) {
        // EC6 o EC7 (senza -13) → 3/8
        if (coupling === "EC6" || coupling === "EC7") {
          return "3/8";
        }
        // EC6-13 o EC7-13 → 1/2
        if (coupling.includes("-13")) {
          return "1/2";
        }
      }

      return null;
    };

    // Filtra escludendo EC7 e costruisce l'array di risultati
    const results = couplings
      .filter((coup) => !coup[0].includes("EC7"))
      .map((coup) => {
        const matched = productsConfiguration.find(
          ({ code }) => code === coup[0]
        );

        if (!matched) return null;

        // Estrae la dimensione
        const dimension = extractDimension(coup[0]);

        // Crea un unico item che unisce fixed e mobile
        // Il nome non ha più il prefisso F/M, ma aggiunge * se è EC6
        const baseName = coup[0].includes("EC6") ? coup[0] + "*" : coup[0];

        return {
          code: matched.fixed + " / " + matched.mobile,
          name: baseName,
          dimension: dimension,
          quantity: coup[1],
        };
      })
      .filter((item) => item !== null);

    // Calcola le dimensioni libere
    const productDimensions = product?.dimensions || {};
    const freeDimensions = { ...productDimensions };

    // Sottrae le linee occupate dalle dimensioni totali
    results.forEach((item) => {
      if (item.dimension && freeDimensions.hasOwnProperty(item.dimension)) {
        freeDimensions[item.dimension] -= item.quantity;
      }
    });

    return freeDimensions;
  };

  // Prima ottiene le free dimensions
  const freeDimensions = getPlugAndSeegerConfiguration();

  // Poi usa le free dimensions per calcolare i plug e seeger disponibili
  const plugSeeger = getPlugSeeger(freeDimensions);

  return (
    <div className="detail-product-component">
      <div className="pop-up-product" ref={propRef}>
        {/* PRIMA ROW: Solo button X */}
        <div className="pop-up__close-row">
          <button
            type="button"
            className="pop-up__close-btn"
            aria-label="Close detail"
            onClick={close}
          >
            <Icon path={mdiClose} size={2} />
          </button>
        </div>

        {/* SECONDA ROW: Header con nome e logo */}
        <div className="pop-up__header">
          <h4>{title}</h4>
          <img src={logo} alt="Stucchi" />
        </div>

        {/* TERZA ROW: Tabella configurazione */}
        {!catalogue && (
          <div className="pop-up__table-configuration">
            <h2 className="result-title">YOUR LINES CONFIGURATION</h2>
            {circles.find((value) => value?.type === "hydraulic") && (
              <Specs circles={circles} type="hydraulic" />
            )}

            {circles.find((value) => value?.type === "electric") && (
              <Specs circles={circles} type="electric" />
            )}
          </div>
        )}

        {/* QUARTA ROW: Immagine prodotto */}
        {image() && (
          <div className="pop-up__image-product">
            <img className="result-img no-event" src={image()} alt=""></img>
            <div className="pop-up__image-product-caption">
              <p className="pop-up__image-product-caption-text">
                The image is for illustrative purposes only, please refer to the
                drawings in the Stucchi catalog.
              </p>
            </div>
          </div>
        )}

        {/* INGOMBRI */}
        {product.ingombri && (
          <a
            className="btn ingombri"
            href={product.ingombri}
            target="_blank"
            rel="noopener noreferrer"
          >
            Dimensions datasheet
          </a>
        )}

        {/* QUINTA ROW: Corpo della popup */}
        <div className="pop-up__body" ref={ref}>
          {/* NOT EMPTY PRODUCT */}
          {(type === "COMPLETE" || type === "FIX" || type === "MOBILE") &&
            (!product.name.includes("EMPTY") || catalogue) && (
              <>
                {/* SELECTED PRODUCT (COMPLETE, FIX OR MOBILE) */}
                <div className="table-title">selected product</div>
                <table className="detail-product-table detail-product-table--type-a">
                  <thead>
                    <tr>
                      <th>code</th>
                      <th>name</th>
                      <th>description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="Code">{product.code}</td>
                      <td data-label="Name">{product.name}</td>
                      <td data-label="Description">
                        {product.description || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="table-note">
                  <p>Max operating resistance is {product.max_resistance}</p>
                </div>

                {/* COMPONENTS INCLUDED (COMPLETE, FIX OR MOBILE) */}
                {!product.name.includes("EMPTY") && (
                  <>
                    <div className="table-title">Components included</div>
                    <table className="detail-product-table detail-product-table--type-b">
                      <thead>
                        <tr>
                          <th>code</th>
                          <th>quantity</th>
                          <th>description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products
                          .filter((prod) => {
                            if (type !== "COMPLETE") {
                              return (
                                prod.picture === product.picture &&
                                prod.name.includes("EMPTY") &&
                                prod.name.includes(
                                  type === "FIX" ? "FIX" : "MOBILE"
                                )
                              );
                            } else {
                              if (!product.name.includes("V0")) {
                                return (
                                  prod.picture === product.picture &&
                                  prod.name.includes("EMPTY") &&
                                  !prod.name.includes("V0")
                                );
                              } else {
                                return (
                                  prod.picture === product.picture &&
                                  prod.name.includes("EMPTY")
                                );
                              }
                            }
                          })
                          .map((component, i) => {
                            return (
                              <Fragment key={i}>
                                <tr>
                                  <td data-label="Code">{component.code}</td>
                                  <td data-label="Quantity">1</td>
                                  <td data-label="Description">
                                    {" "}
                                    {component.name}
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          })}

                        {filteredCouplings.map((coup, i) => {
                          const matched = productsConfiguration.find(
                            ({ code }) => code === coup[0]
                          );
                          // Raddoppia la quantità per i SEEGER (1 per piastra fissa + 1 per mobile)
                          const quantity = coup[0].includes("SEEGER")
                            ? coup[1] * 2
                            : coup[1];

                          return (
                            <Fragment key={i}>
                              {(type === "COMPLETE" || type === "MOBILE") && (
                                <tr>
                                  <td data-label="Code">
                                    {matched && matched.fixed}
                                  </td>
                                  <td data-label="Quantity">{quantity}</td>
                                  <td data-label="Description">
                                    {"F " + coup[0]}
                                  </td>
                                </tr>
                              )}

                              {(type === "COMPLETE" || type === "FIX") &&
                                !coup[0].includes("SEEGER") && (
                                  <tr>
                                    <td data-label="Code">
                                      {matched && matched.mobile}
                                    </td>
                                    <td data-label="Quantity">{coup[1]}</td>
                                    <td data-label="Description">
                                      {"M " + coup[0]}
                                    </td>
                                  </tr>
                                )}
                            </Fragment>
                          );
                        })}

                        {product.cap && (
                          <tr>
                            <td data-label="Code">
                              {product.cap?.split(" ")[0]}
                            </td>
                            <td data-label="Quantity">1</td>
                            <td data-label="Description">
                              {spareParts.join(" ")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                )}

                {/* RELATED PRODUCTS (COMPLETE) */}
                {type === "COMPLETE" &&
                  products.filter(
                    (prod) =>
                      prod.description === product.description?.split(" -")[0]
                  ).length > 0 &&
                  products.filter((prod) => {
                    const mobileCode = replaceChar(product.code, "1", -3);

                    const fixCode = replaceChar(product.code, "2", -3);

                    return prod.code === mobileCode || prod.code === fixCode;
                  }).length > 0 && (
                    <>
                      <div className="table-title">Related Products</div>
                      <table className="detail-product-table detail-product-table--type-b">
                        <thead>
                          <tr>
                            <th>code</th>
                            <th>quantity</th>
                            <th>description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products
                            .filter((prod) => {
                              const mobileCode = replaceChar(
                                product.code,
                                "1",
                                -3
                              );

                              const fixCode = replaceChar(
                                product.code,
                                "2",
                                -3
                              );

                              return (
                                prod.code === mobileCode ||
                                prod.code === fixCode
                              );
                            })
                            .map((component, i) => {
                              console.log("component: ", component);
                              return (
                                <Fragment key={i}>
                                  <tr>
                                    <td data-label="Code">{component.code}</td>
                                    <td data-label="Quantity">1</td>
                                    <td data-label="Description">
                                      {" "}
                                      {component.name}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                        </tbody>
                      </table>
                    </>
                  )}

                {/* RELATED PRODUCTS (MOBILE OR FIX) */}
                {(type === "MOBILE" || type === "FIX") && (
                  <>
                    <div className="table-title">Related Products</div>
                    <table className="detail-product-table detail-product-table--type-b">
                      <thead>
                        <tr>
                          <th>code</th>
                          <th>quantity</th>
                          <th>description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products
                          .filter(
                            (prod) =>
                              prod.picture === product.picture &&
                              prod.name.includes("EMPTY") &&
                              prod.name.includes(
                                type !== "FIX" ? "FIX" : "MOBILE"
                              )
                          )
                          .map((component, i) => {
                            return (
                              <Fragment key={i}>
                                <tr>
                                  <td data-label="Code">{component.code}</td>
                                  <td data-label="Quantity">1</td>
                                  <td data-label="Description">
                                    {" "}
                                    {component.name}
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          })}

                        {filteredCouplings.map((coup, i) => {
                          const matched = productsConfiguration.find(
                            ({ code }) => code === coup[0]
                          );
                          // Raddoppia la quantità per i SEEGER (1 per piastra fissa + 1 per mobile)
                          const quantity = coup[0].includes("SEEGER")
                            ? coup[1] * 2
                            : coup[1];

                          return (
                            <Fragment key={i}>
                              {type !== "MOBILE" &&
                                !product.name.includes("EMPTY") && (
                                  <tr>
                                    <td data-label="Code">
                                      {matched && matched.fixed}
                                    </td>
                                    <td data-label="Quantity">{quantity}</td>
                                    <td data-label="Description">
                                      {"F " + coup[0]}
                                    </td>
                                  </tr>
                                )}

                              {type !== "FIX" &&
                                !product.name.includes("EMPTY") &&
                                !coup[0].includes("SEEGER") && (
                                  <tr>
                                    <td data-label="Code">
                                      {matched && matched.mobile}
                                    </td>
                                    <td data-label="Quantity">{coup[1]}</td>
                                    <td data-label="Description">
                                      {"M " + coup[0]}
                                    </td>
                                  </tr>
                                )}
                            </Fragment>
                          );
                        })}

                        {product.cap && type !== "FIX" && (
                          <tr>
                            <td data-label="Code">
                              {product.cap?.split(" ")[0]}
                            </td>
                            <td data-label="Quantity">1</td>
                            <td data-label="Description">
                              {spareParts.join(" ")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* AVAILABLE UPON REQUEST (COMPLETE OR FIX) */}
                    {parkingStation && type !== "MOBILE" && (
                      <>
                        <div className="table-title">
                          Available upon request
                        </div>
                        <table className="detail-product-table detail-product-table--type-c">
                          <thead>
                            <tr>
                              <th>code</th>
                              <th>name</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td data-label="Code">
                                {product.parking_station.split(" ")[0]}
                              </td>
                              <td data-label="Name">
                                {parkingStation.slice(0).join(" ")}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                )}

                {/* AVAILABLE UPON REQUEST (MOBILE) */}
                {parkingStation && (
                  <>
                    <div className="table-title">Available upon request</div>
                    <table className="detail-product-table detail-product-table--type-c">
                      <thead>
                        <tr>
                          <th>code</th>
                          <th>name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Code">
                            {product.parking_station.split(" ")[0]}
                          </td>
                          <td data-label="Name">
                            {parkingStation.slice(0).join(" ")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}
              </>
            )}

          {/* EMPTY PRODUCT */}
          {product.name.includes("EMPTY") && !catalogue && (
            <>
              {/* SELECT PRODUCT */}
              <div className="table-title">Selected product</div>
              <table className="detail-product-table detail-product-table--type-b">
                <thead>
                  <tr>
                    <th>code</th>
                    <th>quantity</th>
                    <th>description</th>
                  </tr>
                </thead>
                <tbody>
                  {relatedEmpties.map((component, i) => {
                    return (
                      <Fragment key={i}>
                        <tr>
                          <td data-label="Code">{component.code}</td>
                          <td data-label="Quantity">1</td>
                          <td data-label="Description"> {component.name}</td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
              {relatedEmpties.length > 0 &&
                relatedEmpties[0].max_resistance && (
                  <div className="table-note">
                    <p>
                      Max operating resistance is{" "}
                      {relatedEmpties[0].max_resistance}
                    </p>
                  </div>
                )}

              {/* COMPONENTS NOT INCLUDED WITH THE PLATES (TO BE ORDERED SEPARATELY) */}
              <div className="table-title">
                Components not included with the plates (to be ordered
                separately)
              </div>
              <table className="detail-product-table detail-product-table--type-b">
                <thead>
                  <tr>
                    <th>code</th>
                    <th>quantity</th>
                    <th>description</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCouplings
                    .filter((coup) => !coup[0].includes("EC7"))
                    .map((coup, i) => {
                      const matched = productsConfiguration.find(
                        ({ code }) => code === coup[0]
                      );

                      return (
                        <Fragment key={i}>
                          <tr>
                            <td data-label="Code">
                              {matched && matched.fixed}
                            </td>
                            <td data-label="Quantity">{coup[1]}</td>
                            {coup[0].includes("EC6") ? (
                              <td data-label="Description">
                                {"F " + coup[0] + "*"}
                              </td>
                            ) : (
                              <td data-label="Description">
                                {"F " + coup[0]}{" "}
                              </td>
                            )}
                          </tr>
                          <tr>
                            <td data-label="Code">
                              {matched && matched.mobile}
                            </td>
                            <td data-label="Quantity">{coup[1]}</td>
                            {coup[0].includes("EC6") ? (
                              <td data-label="Description">
                                {"M " + coup[0] + "*"}
                              </td>
                            ) : (
                              <td data-label="Description">
                                {"M " + coup[0]}{" "}
                              </td>
                            )}
                          </tr>
                        </Fragment>
                      );
                    })}

                  {relatedEmpties
                    .filter((prod) => prod.cap)
                    .map((product, i) => {
                      return (
                        <Fragment key={i}>
                          <tr>
                            <td data-label="Code">
                              {product.cap?.split(" ")[0]}
                            </td>
                            <td data-label="Quantity">1</td>
                            <td data-label="Description">
                              {splitAndShift(product.cap)}
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })}

                  {relatedEmpties
                    .filter((prod) => typeof prod.parking_station === "string")
                    .map((product, i) => {
                      return (
                        <Fragment key={i}>
                          <tr>
                            <td data-label="Code">
                              {product.parking_station.split(" ")[0]}
                            </td>
                            <td data-label="Quantity">1</td>
                            <td data-label="Description">
                              {splitAndShift(product.parking_station)}
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })}

                  {plugSeeger.map((item, i) => {
                    return (
                      <Fragment key={i}>
                        <tr>
                          <td data-label="Code">{item.code}</td>
                          <td data-label="Quantity">{item.quantity}</td>
                          <td data-label="Description">{item.description}</td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
              {!catalogue &&
                circles.find((value) => value?.type === "electric") && (
                  <div className="ec-other-note">
                    * Standard EC with{" "}
                    {circles.find((value) => value?.type === "electric")
                      ?.setting?.poles?.value || 6}{" "}
                    poles; other versions available upon request
                  </div>
                )}
            </>
          )}
        </div>

        {product.name.includes("EMPTY") && !catalogue && (
          <Warning
            product={product}
            base64={base64}
            allResultsBase64={allResultsBase64}
            catalogue={catalogue}
          />
        )}

        <div className="btn-container">
          <div>
            <Link
              className="btn center"
              to={{
                pathname: "/form",
                state: { product, base64, allResultsBase64, catalogue },
              }}
            >
              Request Info
            </Link>
          </div>
          <div>
            <div
              onClick={() =>
                printPdf(
                  catalogue,
                  circles,
                  product,
                  getProductType(product).split(" ")[1],
                  filteredCouplings,
                  "printPage",
                  imgBase64,
                  formattedPlacca,
                  logoBase64
                )
              }
              className="btn outline"
            >
              Print PDF
            </div>
          </div>
          <div>
            <a
              className="btn outline danger"
              href="/stucchi_multicoupling_warnings_v2.pdf"
              target="_blank"
              onClick={() =>
                window.dataLayer.push({
                  event: "download_notice",
                })
              }
            >
              Important Notice / Instructions
            </a>
          </div>
          {videoLink && (
            <div>
              <a
                className="btn outline video"
                href={videoLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Video Tutorial
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailProduct;

const Warning = ({ product, base64, allResultsBase64, catalogue }) => (
  <div className="warning-box">
    <div className="warning-box__icon">
      <Danger fill="#e6007e" size={24} />
    </div>
    <div className="warning-box__content">
      <p className="warning-box__title">
        Please{" "}
        <Link
          className="warning-box__link"
          to={{
            pathname: "/form",
            state: {
              product,
              base64,
              allResultsBase64,
              catalogue,
            },
          }}
        >
          address to Stucchi Technical Service
        </Link>{" "}
        for more information.
      </p>
      <p className="warning-box__text">
        The force applied to multicoupling coupled depends on the number of
        couplings under pressure at the same time, on their operating pressure
        and on their size. For a correct use of the multicoupling it is
        necessary to verify that the force is not higher than the maximum
        resistance of the multicoupling.
      </p>
    </div>
  </div>
);
